import { render } from "./AssignSalespersonContacts.vue?vue&type=template&id=3b22ad79&scoped=true"
import script from "./AssignSalespersonContacts.vue?vue&type=script&lang=js"
export * from "./AssignSalespersonContacts.vue?vue&type=script&lang=js"

import "./AssignSalespersonContacts.vue?vue&type=style&index=0&id=3b22ad79&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b22ad79"]])

export default __exports__